import mainServerClient from "@/services/http/mainServerClient";

/**发送验证码 */
export function sendSmsCode(captchaKey: string, captchaText: string, mobile: string): Promise<void> {
    return mainServerClient.get("/sms_code/send", { captchaText, captchaKey, mobile });
}

/**获取登录token */
export function validateSmsCode(mobile: string, smsCode: string): Promise<{ token: string }> {
    return mainServerClient.post("/sms_code/validate", { mobile, smsCode });
}
